var slides = document.getElementsByClassName('parks-areas-one-slider--item');
var anchors = document.getElementsByClassName('parks-areas-list--title');

var prevButton = document.getElementById('parks-areas-button-prev');
var nextButton = document.getElementById('parks-areas-button-next');

var upNext = document.getElementsByClassName('upnext-link--parks');

var area = document.getElementById('parks-areas');

var slidesLength = slides.length;
var anchorsLength = anchors.length;

for (let i = 0; i < anchorsLength; i++) {
    anchors[i].addEventListener('click', function() {
        for (var o = 0; o < anchorsLength; o++) {
            anchors[o].classList.remove('active');
        }
        this.classList.add('active');
        for (var x = 0; x < slidesLength; x++) {
            slides[x].classList.remove('active');
        }
        slides[i].classList.add('active');

        if (i == slidesLength - 1) {
            nextButton.classList.add('disabled');
        } else {
            nextButton.classList.remove('disabled');
        }
        if (i == 0) {
            prevButton.classList.add('disabled');
        } else {
            prevButton.classList.remove('disabled');
        }
    })
}

if (prevButton) {
    prevButton.addEventListener('click', function() {
        if (prevButton.classList.contains('disabled')) {
            //Do nothing
        } else {
            for (let i = 0; i < slidesLength; i++) {
                if (slides[i].classList.contains('active')) {
                    slides[i].classList.remove('active');
                    slides[i - 1].classList.add('active');
                    console.log(area);
                    area.scrollIntoView();

                    if (i - 1 == 0) {
                        nextButton.classList.remove('disabled');
                        prevButton.classList.add('disabled');
                    } else {
                        nextButton.classList.remove('disabled');
                    }
                    for (var o = 0; o < anchorsLength; o++) {
                        anchors[o].classList.remove('active');
                    }
                    anchors[i - 1].classList.add('active');
                    break;
                }
            }
        }
    })
}

if (nextButton) {

    nextButton.addEventListener('click', function() {
        if (nextButton.classList.contains('disabled')) {
            //Do nothing
        } else {
            for (let i = 0; i < slidesLength; i++) {
                if (slides[i].classList.contains('active')) { 
                    slides[i].classList.remove('active');
                    slides[i + 1].classList.add('active');

                    if (i + 1 == slidesLength - 1) {
                        nextButton.classList.add('disabled');
                        prevButton.classList.remove('disabled');
                    } else {
                        nextButton.classList.remove('disabled');
                        prevButton.classList.remove('disabled');
                    }
                    for (var o = 0; o < anchorsLength; o++) {
                        anchors[o].classList.remove('active');
                    }
                    anchors[i + 1].classList.add('active');

                    break;
                }
            }
        }
    })
}

if (upNext) {
    for (let i = 0; i < upNext.length; i++) {
        upNext[i].addEventListener('click', function() {
            slides[i].classList.remove('active');
            slides[i + 1].classList.add('active');

            if (i + 1 == slidesLength - 1) {
                nextButton.classList.add('disabled');
                prevButton.classList.remove('disabled');
            } else {
                nextButton.classList.remove('disabled');
                prevButton.classList.remove('disabled');
            }

            for (var o = 0; o < anchorsLength; o++) {
                anchors[o].classList.remove('active');
            }
            anchors[i + 1].classList.add('active');
        })
    }
}